import { z } from 'zod';
import { HexColorSchema, deletedFilterFields, refineDeletedFilterMutualExclusion } from './common.js';
/**
 * Strict (CTSK-445) — unknown keys are rejected with 400
 * VALIDATION_ERROR naming the offending key, instead of Zod's default
 * silent strip. Class-fix for the CTSK-427 silent-drop bug (memory
 * feedback_zod_field_name_silent_drop).
 */
export const TagCreateSchema = z.object({
    name: z.string().min(1).max(100).regex(/^[^,]+$/, 'no commas allowed'),
    color: HexColorSchema,
    description: z.string().max(500).nullable().optional(),
}).strict();
// .strip() restores Zod's default unknown-key tolerance for PATCH —
// CTSK-445 made Create strict, and .partial() would otherwise inherit
// `unknownKeys: "strict"`. Patch semantics deliberately unchanged.
export const TagPatchSchema = TagCreateSchema.partial().strip();
// CTSK-388 (Phase 2 of CTSK-385) — first list-query schema for tags.
// `GET /tags` previously read no query params at all and returned
// soft-deleted rows unconditionally; this closes that gap.
export const TagsListQuerySchema = z
    .object({
    ...deletedFilterFields,
})
    .superRefine(refineDeletedFilterMutualExclusion);
//# sourceMappingURL=tag.js.map